module.exports = __webpack_public_path__ + "img/dracula-26.dd855846.jpg";